import React from "react";
import headerImg from "./images/kc_logo.png";
import logo1 from "./images/logo1.png";
import logo2 from "./images/logo2.png";
import logo3 from "./images/logo3.png";

import "./style.css";

const Home = () => {
    const handleClick = (e, path) => {
        e.preventDefault();
        // window.location.href = path;
    }

    return (
        <>
            <title>Global WEM Showcase Website</title>
            <header className="home-header">
                <div>
                    <img
                        src={headerImg}
                        alt="Kimberly-Clark"
                        className="header-logo"
                    />
                </div>
                <h1>Global WEM Showcase Website</h1>
            </header>
            <div className="cards-container">
                <div className="box">
                    <div className="cards">
                        <article className="card">
                            <div>
                                <figure className="card-thumb">
                                    <img src={logo1} alt="angular" />
                                </figure>
                                <div className="card-content">
                                    <h2 className="card-title">
                                        WEM Enterprise Library
                                    </h2>
                                    <div className="card-desc">
                                        <p className="card-excerpt">
                                            WEM Enterprise library is group of
                                            tools which contains the list of
                                            Global Platform – Utilities.
                                        </p>
                                        <div className="cta-links">
                                            <a
                                                href="/utility"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Utility Tools
                                            </a>
                                            <a
                                                href="/master-design/project/wem-core-libraries.html"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                WEM Core Libraries
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                        <article className="card">
                            <div>
                                <figure className="card-thumb">
                                    <img src={logo2} alt="react" />
                                </figure>
                                <div className="card-content">
                                    <h2 className="card-title">
                                        WEM Brand.com Page Templates
                                    </h2>
                                    <div className="card-desc">
                                        <p className="card-excerpt">
                                            Global reusable components are
                                            integrated in Brand.com page
                                            templates. Core library contains the
                                            list of all Page templates.
                                        </p>
                                        <div className="cta-links">
                                            <a
                                                href="/master-design/project/wem-page-template.html"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                WEM Page Template
                                            </a>
                                            <a
                                                href="/feminine-care/kotex/lao/project/index.html"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Kotex LAO
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                        <article className="card">
                            <div>
                                <figure className="card-thumb">
                                    <img src={logo3} alt="vue" />
                                </figure>
                                <div className="card-content">
                                    <h2 className="card-title">
                                        Brand Reference Website
                                    </h2>
                                    <div className="card-desc">
                                        <p className="card-excerpt">
                                            Many of the Consumer Brand sites are
                                            migrated to Brand.com from different
                                            Regions, Markets and Brands. Core
                                            library contains the list of all
                                            sites integrated with brand.com page
                                            templates.
                                        </p>
                                        <div className="cta-links">
                                            <a
                                                href="/baby-child-care/huggies/common/project/brand-reference-website-huggies.html"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Huggies
                                            </a>
                                            <a
                                                href="/feminine-care/kotex/emea/project/brand-reference-website-kotex.html"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Kotex
                                            </a>
                                            <a
                                                href="/feminine-care/kotex/common/project/brand-reference-website-ubykotex.html"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                UByKotex
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;